import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy, RouterModule} from '@angular/router';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {InAppBrowser} from '@ionic-native/in-app-browser/ngx';

import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {PartialsModule} from './partials/partials.module';
import {IonicStorageModule} from '@ionic/storage';
import {WifiWizard2} from '@ionic-native/wifi-wizard-2/ngx';
import {Insomnia} from '@ionic-native/insomnia/ngx';
import {AndroidPermissions} from '@ionic-native/android-permissions/ngx';
import {BarcodeScanner} from '@awesome-cordova-plugins/barcode-scanner/ngx';
import {Serial} from '@ionic-native/serial/ngx';
import { PipesModule } from './pipes/pipes.module';
import {Network} from '@ionic-native/network/ngx';
import {AppUpdate} from '@ionic-native/app-update/ngx';
import {AppVersion} from '@ionic-native/app-version/ngx';
import {ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx';
import {NavigationBar} from '@ionic-native/navigation-bar/ngx';
import {AndroidFullScreen} from '@awesome-cordova-plugins/android-full-screen/ngx';
import {CoreModule} from './core/core.module';
import {ConfigCheckerModule} from './config-checker/config-checker.module';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        RouterModule,
        BrowserModule,
        IonicModule.forRoot({
            animated: false,
            swipeBackEnabled: false,
            platform: {
                // The default `desktop` function returns false for devices with a touchscreen.
                // This is not always wanted, so this function tests the User Agent instead.
                desktop: (win) => {
                    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(win.navigator.userAgent);
                    return !isMobile;
                }
            },
        }),
        AppRoutingModule,
        HttpClientModule,
        CoreModule,
        // TranslateModule.forRoot({
        //     loader: {
        //         provide: TranslateLoader,
        //         useFactory: (createTranslateLoader),
        //         deps: [HttpClient]
        //     }
        // }),
        IonicStorageModule.forRoot({
            name: 'vitality',
            driverOrder: ['sqlite', 'indexeddb', 'websql']
        }),
        PartialsModule,
        PipesModule,
        ConfigCheckerModule
    ],
    providers: [
      AppUpdate,
      AppVersion,
        StatusBar,
        SplashScreen,
        BarcodeScanner,
        WifiWizard2,
        Serial,
        Insomnia,
        InAppBrowser,
        AndroidPermissions,
        Network,
        ScreenOrientation,
        NavigationBar,
        AndroidFullScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
